import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { MessageService } from 'primeng/api';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { UserService } from '@core/services/user.service';
import { finalize } from 'rxjs';
import { PrimeNgSettings } from '@core/static/primeng.static';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'tr-login',
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    ReactiveFormsModule,
    RouterModule,
    MessageModule,
  ],
  templateUrl: './Login.component.html',
  styleUrl: './Login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  private router = inject(Router);
  private messageService = inject(MessageService);
  private cdr = inject(ChangeDetectorRef);
  private userService = inject(UserService);

  loginForm: FormGroup;
  showPassword: boolean = false;
  submitting: boolean = false;

  hasInviteCode: boolean = false;

  constructor() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(4)]),
    });

    const inviteCode = sessionStorage.getItem('inviteCode');
    if (inviteCode) {
      this.hasInviteCode = true;
    }
  }

  ngOnInit(): void {}

  onSubmit() {
    this.loginForm.markAllAsTouched();

    if (this.loginForm.valid) {
      this.submitting = true;

      this.userService
        .loginEmail(this.loginForm.value.email, this.loginForm.value.password)
        .pipe(
          finalize(() => {
            this.submitting = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: (user) => {
            // Redirect after succesfully login
            const inviteCode = sessionStorage.getItem('inviteCode');
            if (inviteCode) {
              this.router.navigate(['invite', inviteCode]);
            } else {
              this.router.navigate(['/']);
            }
          },
          error: () => {
            this.messageService.add({
              severity: 'warn',
              key: 'main-toast',
              summary: 'Failed',
              detail: 'Sorry, your login failed, please check your email/password and try again',
              life: PrimeNgSettings.MessageLife,
            });
          },
        });
    }
  }
}
